import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { BooleanFieldComponentProps } from "../../types";

const GroupOptions: React.FC<BooleanFieldComponentProps> = ({
  options,
  handleBooleanOptionChange,
  isReadOnly,
}) => {
  // グループオプション
  const groupOptions = [
    { key: "noLabel", label: "フィールド名を表示しない" },
    { key: "openGroup", label: "グループ内フィールドの表示" },
  ];

  return (
    <>
      {/* チェックボックスオプション */}
      {groupOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            disabled={isReadOnly || false}
          />
        </div>
      ))}
    </>
  );
};

export default GroupOptions;
